import React from 'react';
import '../Assets/Css/civilconstruction.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutcivil from '../Assets/Images/samshree_civilconstruction1.jpg';
import sitePreparation from '../Assets/Images/sitepreparation.avif';
import structuralWork from '../Assets/Images/structuralwork.avif';
import finishingWork from '../Assets/Images/constructionfinishing.jpg';
import civilcta from '../Assets/Images/samshree_civilconstruction12.jpg';

import { FaHardHat, FaBuilding, FaTools } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

import RetainingWall from '../Assets/Images/samshree_civilconstruction1.jpg';
import RaftConcrete from '../Assets/Images/samshree_civilconstruction3.jpg';
import RobAbutmentCap from '../Assets/Images/samshree_civilconstruction4.jpg';
import RobRaft from '../Assets/Images/samshree_civilconstruction5.jpg';
import RobFinalLift from '../Assets/Images/samshree_civilconstruction6.jpg';
import RubSlabCuring from '../Assets/Images/samshree_civilconstruction7.jpg';
import RubWingWall from '../Assets/Images/samshree_civilconstruction8.jpg';
import RobBarBinding from '../Assets/Images/samshree_civilconstruction9.jpg';
import RobWallConcrete from '../Assets/Images/samshree_civilconstruction10.jpg';
import GirderErection from '../Assets/Images/samshree_civilconstruction11.jpg';
import WearingCoat from '../Assets/Images/samshree_civilconstruction14.jpg';
import StonePitching from '../Assets/Images/samshree_civilconstruction13.jpg';

export default function CivilConstruction() {
  const testimonials = [
    {
      message: "Top-notch construction service! Timely completion and excellent quality.",
      author: "MD at Skyline Builders",
    },
    {
      message: "Reliable team with deep industry knowledge. Highly recommended.",
      author: "Site Manager ",
    },
    {
      message: "Great structural work with attention to detail and safety.",
      author: "Architect ",
    },
  ];

  const features = [
    {
      id: 1,
      icon: <FaHardHat />,
      title: "Expert Workforce",
      description: "Our skilled laborers and engineers ensure high-quality outcomes.",
    },
    {
      id: 2,
      icon: <FaBuilding />,
      title: "On-Time Delivery",
      description: "Strict project management guarantees timely completion.",
    },
    {
      id: 3,
      icon: <FaTools />,
      title: "Modern Equipment",
      description: "We use advanced machinery and techniques for optimal results.",
    },
  ];

  const services = [
    {
      title: 'Site Preparation',
      description: 'Land clearing, leveling, and foundation setup for your projects.',
      image: sitePreparation,
    },
    {
      title: 'Structural Work',
      description: 'Construction of core structures, concrete framing, and support.',
      image: structuralWork,
    },
    {
      title: 'Finishing Work',
      description: 'Plastering, tiling, painting, and handover finishing.',
      image: finishingWork,
    },
  ];

  const constructionData = [
    { title: 'Retaining Wall work', image: RetainingWall },
    { title: 'Retaining Wall Raft concrete', image: RaftConcrete },
    { title: 'ROB Abutment Cap Concrete work', image: RobAbutmentCap },
    { title: 'ROB Raft concrete work', image: RobRaft },
    { title: 'ROB Abutment Final lift Concrete', image: RobFinalLift },
    { title: 'RUB Slab curing work', image: RubSlabCuring },
    { title: 'RUB Wing Wall lift-wise Concrete', image: RubWingWall },
    { title: 'ROB Raft Bar Binding completed', image: RobBarBinding },
    { title: 'ROB Abutment Wall Concrete', image: RobWallConcrete },
    { title: 'Super Structure Steel Girder Erection Work - 24 Mtr Railway Span', image: GirderErection },
    { title: 'Wearing coat @ ROB', image: WearingCoat },
    { title: 'Stone Pitching work @ RUB', image: StonePitching },
  ];


  return (
    <div className="mainnav min-vh-100">
      <Helmet>
        <title>Civil Construction Services | Trusted Construction Experts | Samashree Enterprises</title>
        <meta
          name="description"
          content="Samashree Enterprises provides turnkey civil construction solutions including site preparation, structural work, and finishing for residential, commercial, and industrial projects."
        />
        <meta
          name="keywords"
          content="civil construction, site preparation, structural work, finishing work, residential construction, commercial construction, industrial construction, turnkey projects"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.samashreeenterprises.com/civil-construction-services" />

        {/* Open Graph */}
        <meta property="og:title" content="Civil Construction Services | Samashree Enterprises" />
        <meta
          property="og:description"
          content="Expert civil construction services from site prep to finishing. Skilled workforce and modern equipment ensure timely and quality delivery."
        />
        <meta property="og:url" content="https://www.samashreeenterprises.com/civil-construction-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.samashreeenterprises.com/images/civil-construction-banner.jpg" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Civil Construction Services | Samashree Enterprises" />
        <meta
          name="twitter:description"
          content="Trusted civil construction experts delivering turnkey solutions for residential, commercial, and industrial projects."
        />
        <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/civil-construction-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-sectioncivil">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Civil Construction Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">From concept to completion – we build your vision</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Get in Touch</a>
        </div>
      </section>

      {/* About Us */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={6} className="d-flex justify-content-center align-items-center">
              <img src={aboutcivil} alt="About Civil Construction"
                className="img-fluid aboutsecimg rounded shadow mb-3" data-aos="zoom-in" data-aos-delay="100" />
            </Col>
            <Col md={6}>
              <h2 className="page-title text-center" data-aos="fade-up" > Overview</h2>
              <p data-aos="zoom-in" data-aos-delay="100">
                We are a trusted civil construction company offering turnkey solutions
                for residential, commercial, and industrial projects. Our services range
                from land development to final handover.
              </p>
              <p data-aos="zoom-in" data-aos-delay="100">
                We have experienced team for construction work. Our team has enough experience in the construction of Major bridges, minor bridges, different type of underpasses, RUB & ROB’s ensuring safety and quality of structures.
              </p>
              <ul data-aos="zoom-in" data-aos-delay="100">
                <li>Experienced engineers & skilled workforce</li>
                <li>End-to-end project management</li>
                <li>Strict safety and quality standards</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section>
        <h2 className="page-title text-center" data-aos="fade-up" >Why Choose Us</h2>
        <section className="why-choose-us-bg2 py-4 bg-light">
          <Container>
            <Row className="text-center">
              {features.map(({ id, icon, title, description }) => (
                <Col key={id} md={4} className="mb-4">
                  <Card className="feature-card h-100 p-4 shadow-sm" data-aos="zoom-in" data-aos-delay="100">
                    <div className="icon-box mb-3" style={{ fontSize: "2.5rem", color: "#008080" }}>
                      {icon}
                    </div>
                    <Card.Title>{title}</Card.Title>
                    <Card.Text>{description}</Card.Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </section>

      <section className="construction-section py-5">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">
            Construction Work
          </h2>
          <Row className="gy-4">
            {constructionData.map((item, index) => (
              <Col key={index} md={6} lg={4} data-aos="zoom-in" data-aos-delay={index * 50}>
                <Card className="construction-card h-100 shadow-sm">
                  <Card.Img variant="top" src={item.image} alt={item.title} className="card-img-top" />
                  <Card.Body>
                    <Card.Text className="card-title fw-semibold text-center" style={{ color: '#008080', textAlign: 'center' }}>
                      {item.title}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Our Services */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up" >Our Civil Construction Services</h2>
          <Row>
            {services.map((service, index) => (
              <Col md={4} sm={12} className="mb-4" key={index}>
                <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
                  <Card.Img variant="top" src={service.image} alt={service.title} className="service-image" />
                  <Card.Body>
                    <Card.Title style={{ color: '#008080', textAlign: 'center' }}>{service.title}</Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="100">
              <h2>Build with Confidence</h2>
              <p className="lead">Contact us for a free consultation and project estimate.</p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img src={civilcta} alt="Construction CTA" className="img-fluid rounded shadow" data-aos="zoom-in" data-aos-delay="100" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">Client Testimonials</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
